export default __webpack_public_path__ + "static/media/Teachmint-mini.79d3d16c.svg";